import { Directive, TemplateRef } from '@angular/core';

export interface SuperTableRowContext<T> {
  $implicit: T;
}

@Directive({
  selector: 'ng-template[superTableRow]',
})
export class SuperTableRowDirective<T> {
  constructor(readonly template: TemplateRef<SuperTableRowContext<T>>) {}
}
